import { Box } from "@chakra-ui/react";
import { Type } from "../DSL/Fonts/Fonts";
import Link from "../DSL/Link/Link";
import Typography, { TVariant } from "../DSL/Typography/Typography";

const PrivacyPolicyPage = () => {
  return (
    <Box>
      <Typography variant={TVariant.ComicSans16}>Privacy Policy</Typography>
      <Typography block my={5} variant={TVariant.ComicSans14}>
        The Doge NFT, Inc. a Cayman Foundation Company (“The Doge NFT”, “we,” “us,” or “our”) operates the Doge Pixel
        Project website and associated services (together, the “Service[s]”). Please read this Privacy Policy carefully
        as it contains important information on who we are, how and why we collect, store, use, and share your personal
        information. It also explains your rights in relation to your personal information and how to contact us or
        supervisory authorities in the event you have a complaint. By using the Services, you agree to this Privacy
        Policy. This Privacy Policy is subject to and incorporated by reference to our{" "}
        <Link isNav to={"/terms"} fontSize={"14px"} size={"sm"} variant={Type.ComicSans} fontWeight={"bold"}>
          Terms and Conditions
        </Link>{" "}
        <br />
        <br />A PDF copy of this Privacy Policy is available{" "}
        <Link to={"PrivacyPolicy.pdf"} fontSize={"14px"} size={"sm"} variant={Type.ComicSans} fontWeight={"bold"}>
          here
        </Link>
        . <br />
        <br />
        Personal information is processed by or on behalf of the controller: Eternal Tunnel Corporation, 228 Park Ave S,
        PMB 45689, New York, New York 10003-1502, or via e-mail at{" "}
        <Link
          to={"mailto:doyou@ownthedoge.com"}
          fontSize={"14px"}
          size={"sm"}
          variant={Type.ComicSans}
          fontWeight={"bold"}
        >
          doyou@ownthedoge.com
        </Link>
        <br />
        <br />
        1. Personal Information We Collect About You. We may collect and use the following personal information that
        identifies, relates to, describes, is reasonable capable of being associated with, or could reasonably be
        linked, directly or indirectly, to you when you use our Services.
        <br />
        <br />
        This information may include your name, contact information, other unique identifiers, financial information,
        information regarding your use of our Services, or any other personal information you voluntarily share with us.
        This personal information is required to provide products and/or services to you. If you do not provide personal
        information we ask for, it may delay or prevent us from providing products and/or services to you.
        <br />
        <br />
        2. How Your Personal Information is Collected and Used. We collect most of this personal information directly
        from you - via our Services. However, we may also collect information:
        <br /> • From publicly accessible sources (e.g., property records);
        <br /> • Directly from a third party (e.g., sanctions screening providers, credit reporting agencies, or
        customer due diligence providers);
        <br /> • From a third party with your consent (e.g., your bank);
        <br /> • From cookies on our website; and
        <br /> • Automated monitoring of our websites and other technical systems, such as our computer networks and
        connections, communications systems, email and messaging systems.
        <br />
        <br />
        We use the personal information listed above for the following business purposes:
        <br /> • To provide our Services to you;
        <br /> • To comply with our legal and regulatory obligations, including in fulfilment of our anti-money
        laundering regulatory obligations;
        <br /> • For the performance of our relationship with you or to take steps at your request before entering into
        a contract;
        <br /> • For our legitimate interests or those of a third party; and
        <br /> • Where you have given consent.
        <br />
        <br />
        Legitimate Interests/Consent: To the extent we rely on our legitimate interests as a legal basis for processing
        of your personal information, we have considered the balance between our own interests (among other things, the
        lawful and efficient operation of our Services) and your interests and we believe that (a) you would reasonably
        expect us to carry out the kind of processing referenced above and (b) such processing will not cause you any
        harm and/or will not seriously impact your rights and freedoms with regard to data privacy. You have the right
        to withdraw any consent given to us for the processing of your personal information. The table below explains
        what we use your personal information for and our reasons for doing so:
        <br />
        <br />
        <table>
          <tr>
            <th>What we use your personal information for</th>
            <th>Our reasons</th>
          </tr>
          <tr>
            <td>To provide Services to you</td>
            <td>
              For the performance of our contract with you or to take steps at your request before entering into a
              contract
            </td>
          </tr>

          <tr>
            <td>To prevent and detect fraud against you, The Doge NFT, Inc. and/or PleasrDAO</td>
            <td>
              For our legitimate interests or those of a third party, i.e. to minimize fraud that could be damaging for
              us and for you
            </td>
          </tr>

          <tr>
            <td>
              Conducting checks to identify our customers and verify their identity Screening for financial and other
              sanctions or embargoes Other processing necessary to comply with professional, legal and regulatory
              obligations that apply to our business
            </td>
            <td>To comply with our legal and regulatory obligations</td>
          </tr>

          <tr>
            <td>
              Gathering and providing information required by or relating to audits, inquiries or investigations by
              regulatory bodies
            </td>
            <td>To comply with our legal and regulatory obligations</td>
          </tr>

          <tr>
            <td>Ensuring business policies are adhered to, e.g. policies covering security and internet use</td>
            <td>
              For our legitimate interests or those of a third party, i.e. to protect trade secrets and other
              commercially valuable information To comply with our legal and regulatory obligations
            </td>
          </tr>

          <tr>
            <td>Operational reasons, such as improving efficiency, training and quality control</td>
            <td>
              For our legitimate interests or those of a third party, i.e. to be as efficient as we can so we can
              deliver the best service for you at the best price
            </td>
          </tr>

          <tr>
            <td>Ensuring the confidentiality of commercially sensitive information</td>
            <td>
              For our legitimate interests or those of a third party, i.e. to protect trade secrets and other
              commercially valuable information To comply with our legal and regulatory obligations
            </td>
          </tr>

          <tr>
            <td>
              Statistical analysis to help us manage our business, e.g. in relation to customer base, product and
              service range or other efficiency measures
            </td>
            <td>
              For our legitimate interests or those of a third party, i.e. to be as efficient as we can so we can
              deliver the best service for you at the best price
            </td>
          </tr>

          <tr>
            <td>Preventing unauthorized access and modifications to systems</td>
            <td>
              For our legitimate interests or those of a third party, i.e. to prevent and detect criminal activity that
              could be damaging for us and for you To comply with our legal and regulatory obligations
            </td>
          </tr>

          <tr>
            <td>Updating customer records</td>
            <td>
              For the performance of our contract with you or to take steps at your request before entering into a
              contract To comply with our legal and regulatory obligations For our legitimate interests or those of a
              third party, e.g. making sure that we can keep in touch with our customers about existing orders and new
              products
            </td>
          </tr>

          <tr>
            <td>Statutory returns</td>
            <td>To comply with our legal and regulatory obligations</td>
          </tr>

          <tr>
            <td>Ensuring safe working practices, staff administration and assessments</td>
            <td>
              To comply with our legal and regulatory obligations For our legitimate interests or those of a third
              party, e.g. to make sure we are following our own internal procedures and working efficiently so we can
              deliver the best service to you
            </td>
          </tr>

          <tr>
            <td>
              Marketing our services and those of selected third parties to:  existing and former customers;  third
              parties who have previously expressed an interest in our services;  third parties with whom we have had
              no previous dealings.
            </td>
            <td>
              For our legitimate interests or those of a third party, i.e. to promote our business to existing and
              former customers
            </td>
          </tr>

          <tr>
            <td>External audits and quality checks</td>
            <td>
              For our legitimate interests or a those of a third party, i.e. to maintain our accreditations so we can
              demonstrate we operate at the highest standards To comply with our legal and regulatory obligations
            </td>
          </tr>
        </table>
        <br />
        <br />
        Promotional Communications. We may use your personal information to send you updates (by email, text message,
        telephone or post) about our products and/or services, including exclusive offers, promotions or new products or
        services. We have a legitimate interest in processing your personal information for promotional purposes (see
        above “How and why we use your personal information”). This means we do not usually need your consent to send
        you promotional communications. However, where consent is needed, we will ask for this consent separately and
        clearly. You have the right to opt out of receiving promotional communications at any time by: • Contacting us
        at doyou@ownthedoge.com; or • Using any “unsubscribe” link in emails or “STOP” number in texts. We may ask you
        to confirm or update your marketing preferences if you instruct us to provide further products and/or services
        in the future, or if there are changes in the law, regulation, or the structure of our business.
        <br />
        <br />
        3. Who We Share Your Personal Information With. For the reasons identified above, we may share personal
        information with:
        <br /> • Our affiliates;
        <br /> • Service providers we use to help deliver our products and/or services to you;
        <br /> • Other third parties we use to help us run our business, such as marketing agencies or website hosts;
        <br /> • Third parties approved by you, including social media sites you choose to link your account to or
        third-party payment providers;
        <br /> • Our insurers and brokers;
        <br /> • Third parties in connection with, or during negotiations of, any reorganization, merger, or sale of our
        business; and
        <br /> • Third parties when we believe it is necessary under applicable law; to enforce our terms and
        conditions; to protect our rights, privacy, safety, or property of yours or others; and to respond to requests
        from courts, law enforcement agencies, regulatory agencies, and other governmental authorities. We only allow
        our service providers to handle your personal information if we are satisfied they take appropriate measures to
        protect your personal information. We may also share personal information with external auditors.
        <br />
        <br />
        4. How Long Your Personal Information Will Be Kept. We will only keep your personal information for as long as
        necessary to fulfill the purposes for which it was collected, including for the purposes of satisfying any
        legal, regulatory, accounting, or reporting requirements. Cross-Border Data Transfers. We may transfer your
        personal information to a third party that is located in a jurisdiction other than the one from which we
        collected your personal information, including to countries that have not been deemed to have an adequate level
        of protection for the rights and freedoms of data subjects. If we do transfer your personal information to
        another jurisdiction, we will do so following due diligence and provided that the data recipient is subject to
        contractual agreements imposing obligations on it to ensure appropriate technical and organization measures are
        implemented and maintained at all times to prevent the unauthorized and unlawful processing of personal
        information, and the accidental loss or destruction of, or damage to, personal information, consistent with our
        obligations under applicable data protection laws.
        <br />
        <br />
        5. Your Rights Under the GDPR. If you are an EU or UK resident, you are entitled to certain rights under the
        GDPR and UK GDPR with respect to personal information that we have collected. We have listed below how these
        rights operate in the context of using our Services.
        <br />
        <br />
        <table>
          <tr>
            <td>Right to Access</td>
            <td>
              The right to be provided with a copy of your personal information {"("}the right of access{")"}
            </td>
          </tr>
          <tr>
            <td>Right to Rectification</td>
            <td>The right to require us to correct any mistakes in your personal informatino</td>
          </tr>
          <tr>
            <td>Right to be Forgotten</td>
            <td>The right to require us to delete your personal information - in certain situations</td>
          </tr>
          <tr>
            <td>Right to Restriction of Processing</td>
            <td>
              The right to require us to restrict processing of your personal information - in certain circumstances,
              e.g. if you contest the accuracy of the data
            </td>
          </tr>
          <tr>
            <td>Right to Data Portability</td>
            <td>
              The right to receive the personal information you provided to us, in a structured, commonly used and
              machine-readable format and/or transmit that data to a third party - in certain situations
            </td>
          </tr>
          <tr>
            <td>Right to Object</td>
            <td>
              The right to object:  at any time to your personal information being processed for direct marketing
              (including profiling);  in certain other situations to our continued processing of your personal
              information, e.g. processing carried out for the purpose of our legitimate interests.
            </td>
          </tr>
          <tr>
            <td>Right Not to be Subject to Automated Individual Decision-Making</td>
            <td>
              The right not to be subject to a decision based solely on automated processing (including profiling) that
              produces legal effects concerning you or similarly significantly affects you
            </td>
          </tr>
        </table>
        <br />
        <br />
        If you would like to exercise any of the above rights or if you have questions about your privacy rights, please
        use the contact details in the How to Exercise Your Rights section.
        <br />
        <br />
        6. Your Rights Under In California. “Shine the Light” and “Eraser” Laws: Residents of the State of California
        may request a list of all third parties to which we have disclosed certain information during the preceding year
        for those third parties’ direct marketing purposes. Do-Not-Track Disclosures. We do not support Do Not Track
        (“DNT”) requests. Do Not Track is a preference you can set in your web browser to inform websites that you do
        not want to be tracked. You can enable or disable Do Not Track by visiting the Preferences or Settings page of
        your web browser
        <br />
        <br />
        7. Keeping Your Personal Information Secure. We have appropriate security measures in place designed to prevent
        personal information from being accidentally lost or used or accessed in an unauthorized way. We limit access to
        your personal information to those who have a genuine business need to access it. Those processing your
        information will do so only in an authorized manner and are subject to a duty of confidentiality. We also have
        procedures in place to deal with any suspected data security breach. We will notify you and any applicable
        regulator of a suspected data security breach where we are legally required to do so. <br />
        <br /> 8. How to Exercise Your Rights. If you would like to exercise any of your rights as described in this
        Privacy Policy, please: • Email us at doyou@ownthedoge.com. <br />
        <br /> 9. How to File a GDPR Complaint. We hope that we can resolve any query or concern you raise about our use
        of your information. The General Data Protection Regulation also gives you right to lodge a complaint with a
        supervisory authority, in the European Union (or European Economic Area) state where you work, normally live, or
        where any alleged infringement of data protection laws occurred. <br />
        <br /> 10. Children. Our Services are not directed to children under the age of 18 and we do not knowingly
        solicit, collect, use, or disclose Personal Information from children under the age of 18. If we become aware
        that a child has provided us with personal information in violation of applicable law, we will delete any
        personal information we have collected, unless we have a legal obligation to keep it. <br />
        <br /> 11. Changes to This Privacy Policy. This privacy notice was published November 2022 and last updated
        November 2022. We may change this Privacy Policy from time to time–when we do, we will inform you via our
        website or other means of contact such as discord. <br />
        <br /> 12. How to Contact Us. Please contact us by email if you have any questions about this Privacy Policy or
        the information we hold about you. Our contact details are shown below:
      </Typography>
    </Box>
  );
};

export default PrivacyPolicyPage;
